if (document.querySelector('header-menu')) {
  document.querySelectorAll('header-menu>details').forEach(el => {
    el.addEventListener('mouseover', (e) => {
      if (!e.currentTarget.open) {
        let details = e.currentTarget;
        details.open = true;
        details.querySelector('summary').setAttribute('aria-expanded', true);

        details.addEventListener('mouseleave', () => {
          details.open = false;
          details.querySelector('summary').setAttribute('aria-expanded', false);

          details.removeEventListener('mouseleave', () => {
            details.open = false;
            details.querySelector('summary').setAttribute('aria-expanded', false);
          })
        })
      }
    })
  })
}
